"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserPersistedInfo = exports.hanTranscurridoSeisMeses = void 0;
const utils_secure_local_storage_1 = __importDefault(require("@gcloud-npm/utils.secure.local-storage"));
/**
 * Comprueba si han transcurrido al menos seis meses entre dos fechas.
 * @param {number} desde - Fecha inicial en milisegundos.
 * @param {number} hasta - Fecha final en milisegundos (actualmente).
 * @returns {boolean} - true si han transcurrido seis meses, false si no.
 */
const hanTranscurridoSeisMeses = (desde, hasta) => {
    const seisMesesEnMilisegundos = 6 * 30 * 24 * 60 * 60 * 1000; // Asumiendo meses de 30 días
    return hasta - desde >= seisMesesEnMilisegundos;
};
exports.hanTranscurridoSeisMeses = hanTranscurridoSeisMeses;
/**
 * Obtiene la información persistida del usuario, verificando si han transcurrido seis meses
 * desde la última actualización. En caso afirmativo, limpia la información.
 * @returns {Object} - Información persistida del usuario.
 */
const getUserPersistedInfo = () => {
    const secureCookieStorageLib = new utils_secure_local_storage_1.default();
    let persistedInfo2Use = {};
    let persistedInfo = secureCookieStorageLib.getItem("ts");
    if (persistedInfo && persistedInfo.ts) {
        const currentDate = Date.now();
        const lastTs = persistedInfo.ts;
        // Verificar si han transcurrido seis meses
        const checkSeisMeses = (0, exports.hanTranscurridoSeisMeses)(lastTs, currentDate);
        if (checkSeisMeses) {
            // Limpiar la información si han pasado seis meses
            persistedInfo = {};
            localStorage.removeItem("ts");
        }
        else {
            // Utilizar la información persistida si no han pasado seis meses
            persistedInfo2Use = Object.assign({}, persistedInfo);
        }
    }
    return persistedInfo2Use;
};
exports.getUserPersistedInfo = getUserPersistedInfo;
//# sourceMappingURL=utils.js.map